import React from 'react';
import { ClockIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { ContactForm } from './ContactForm/ContactForm';
import { useLanguage } from '../hooks/useLanguage';
import { business } from '../data/business';
import { ui } from '../data/translations';
export function Contact() {
  const {
    t
  } = useLanguage();
  return <section id="contact" className="w-full bg-white py-20 lg:py-28" data-id="element-2" data-mp="2w91phx1o44sl">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-[5fr_7fr] lg:gap-16 lg:px-8" data-id="element-3" data-mp="3sxzk9f9f42pr">
        <div data-id="element-4" data-mp="3ovw8epiu6w3y">
          <h2 className="font-display text-3xl font-bold leading-tight text-navy lg:text-4xl" data-id="element-5" data-mp="3oxfks51dgn0g">{t(ui.contact.title)}</h2>
          <p className="mt-4 text-steel" data-id="element-6" data-mp="3k3l8hmo3jabe">{t(ui.contact.subtitle)}</p>

          <div className="mt-10" data-id="element-7" data-mp="3f59z1d1pr1tp">
            <p className="text-sm font-medium text-steel" data-id="element-8" data-mp="3f48ln1x8638t">{t(ui.contact.callDirect)}</p>
            <a href={business.phoneHref} className="mt-1 inline-flex items-center gap-3 font-display text-3xl font-bold text-navy transition-colors duration-150 hover:text-gold-dark sm:text-4xl" data-id="element-9" data-mp="ghnixqbm2lg0">
              <PhoneIcon className="h-7 w-7 text-gold-dark" aria-hidden="true" data-id="element-10" data-mp="3ouefigvd0vo7" />
              {business.phoneDisplay}
            </a>
          </div>

          <dl className="mt-10 space-y-6 border-t border-black/10 pt-8" data-id="element-11" data-mp="3b2rhabhuxd2s">
            <div className="flex gap-4" data-id="element-12" data-mp="3f42ybsmo0pzd">
              <ClockIcon className="mt-0.5 h-5 w-5 shrink-0 text-steel" aria-hidden="true" data-id="element-13" data-mp="3f2rvbv11nm9b" />
              <div data-id="element-14" data-mp="313s88rt6jff9">
                <dt className="text-sm font-semibold text-ink" data-id="element-15" data-mp="317g0zoqsvxsx">{t(ui.contact.hours)}</dt>
                <dd className="text-steel" data-id="element-16" data-mp="3623hb0bnhlwf">{t(business.hours)}</dd>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-17" data-mp="2s6rmyu1epxg1">
              <MapPinIcon className="mt-0.5 h-5 w-5 shrink-0 text-steel" aria-hidden="true" data-id="element-18" data-mp="2w58kclv0ztk9" />
              <div data-id="element-19" data-mp="qcii6b416qsw">
                <dt className="text-sm font-semibold text-ink" data-id="element-20" data-mp="qed7s2q8z73b">{t(ui.contact.area)}</dt>
                <dd className="text-steel" data-id="element-21" data-mp="uex1ewbm3skp">{t(business.serviceArea)}</dd>
              </div>
            </div>
          </dl>
        </div>

        <ContactForm data-id="element-22" data-mp="23cvl0xzccz2v" />
      </div>
    </section>;
}